import React from 'react'
import "./header.css"

const Header = () => {
    return (
        <div>
            <h1> Laptop Recommender </h1>
            <p> 
                Get Best Laptops available in the market
                no matter what your uses are.. We got you covered.
            </p>
        </div>
    )
}

export default Header
